import React from 'react'
import OffLine from '../off-line'

const OffLineNl = () => {
    return <OffLine languageCode="nl" />
}

export default OffLineNl
